import { Navigate, Outlet } from "react-router-dom"
import { useUser } from "@/hooks/useUser"
import Navbar from "@/components/Navbar"

export default function LoketmanLayout() {
  const { user, isPending } = useUser()
  const userRoles = user?.jenis_user || []
  const loketman =
    userRoles.includes("loket_1") ||
    userRoles.includes("loket_2") ||
    userRoles.includes("loket_3") ||
    userRoles.includes("loket_4") ||
    userRoles.includes("loket_5") ||
    userRoles.includes("loket_all")

  if (!isPending && !loketman) return <Navigate to={"/"} />

  return (
    <main>
      <Navbar />
      <section className="container mx-auto lg:px-20 px-4">
        <Outlet />
      </section>
    </main>
  )
}
